import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { ExtranetIncidentOutput } from '../../../types/extranet-api.types';

/**
 * `/v1/extranet/incidents/:id` n'est pas livré par le back (404 PROD).
 * Or `ExtranetIncidentOutput` contient déjà `ride`, `timeline`, `attachments`
 * (et `allocabResponse?`) inline dans la liste — on alimente donc le drawer
 * depuis le cache de la query list au lieu de fetch une route dédiée.
 */
export const useExtranetIncidentDetail = (id: string | null) => {
  const queryClient = useQueryClient();

  const data = useMemo<ExtranetIncidentOutput | undefined>(() => {
    if (!id) return undefined;
    const lists = queryClient.getQueriesData<ListOutput<ExtranetIncidentOutput>>({
      queryKey: ['extranet', 'incidents', 'list'],
    });
    for (const [, listData] of lists) {
      const found = listData?.items?.find(i => i.id === id);
      if (found) return found;
    }
    return undefined;
  }, [id, queryClient]);

  return { data, isLoading: false, isError: false, error: null };
};
